import styled from 'styled-components';
import { Modal } from 'melco-ui'

const StyledModal = styled(Modal)`
  .ant-modal-close {
    right: 24px;
    top: 8px;
  }

  .ant-modal-close:hover {
    background-color: rgba(0, 0, 0, 0.06);
    border-radius: 50%;
  }
`;

export default StyledModal;